import {
    Button,
    FormControl,
    Grid,
    Paper,
    TextField,
  } from "@mui/material";
  import React from "react";
  
  const FilterComponent = ({ filters, setFilters, onApplyFilters }) => {
    const handleInputChange = (e) => {
      const { name, value } = e.target;
      setFilters((prevFilters) => ({ ...prevFilters, [name]: value }));
  
      // Apply filter automatically only if 3+ characters
      if (name === "searchText" && value.length >= 3) {
        onApplyFilters({ ...filters, [name]: value });
      }
  
      // Clear results if search text is emptied
      if (name === "searchText" && value.length === 0) {
        onApplyFilters({ ...filters, [name]: "" });
      }
    };
  
    const resetFilters = () => {
      const reset = { searchText: "" };
      setFilters(reset);
      onApplyFilters(reset);
    };
  
    return (
      <Paper elevation={2} sx={{ mb: 4, p: 3 }}>
        <Grid container spacing={2} alignItems="center">
          {/* Left side: Search */}
          <Grid item xs={12} md={9}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4} md={4}>
                <FormControl fullWidth>
                  <TextField
                    label="Search by Name or Pincode"
                    name="searchText"
                    value={filters.searchText}
                    onChange={handleInputChange}
                    size="small"
                  />
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
  
          {/* Right side: Action buttons */}
          {/* <Grid
            item
            xs={12}
            md={3}
            sx={{
              textAlign: { xs: "left", md: "right" },
              display: "flex",
              justifyContent: { xs: "flex-start", md: "flex-end" },
              alignItems: "center",
            }}
          >
            <Button
              variant="outlined"
              size="small"
              onClick={resetFilters}
              sx={{ mr: 1 }}
            >
              Reset Filters
            </Button>
  
            <Button
              variant="outlined"
              size="small"
              onClick={() => onApplyFilters(filters)}
              sx={{ mr: 1 }}
            >
              Apply Filters
            </Button>
          </Grid> */}
        </Grid>
      </Paper>
    );
  };
  
  export default FilterComponent;
  